import api from '../../api/client';
import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  Button,
  Statistic,
  Alert,
  Space,
  Typography,
} from "antd";
import { CalendarOutlined, PlusOutlined } from "@ant-design/icons";
import axios from "axios";
import { useSelector } from "react-redux";
import config from "../../config";
import AddLeave from "./AddLeave";
import LeaveHistory from "./LeaveHistory";

const { Title, Text } = Typography;

const LeavePage = () => {
  const [balance, setBalance] = useState(0);
  const [isPopupVisible, setPopupVisible] = useState(false);
  const account = useSelector((state) => state.account.user);
  const userId = account.id;
  const environment =
    window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;

  const fetchBalance = async () => {
    try {
      const { data } = await api.get(`/leave/balance/${userId}`);
      setBalance(data.leave_days);
    } catch (error) {
      console.error("Error fetching leave balance:", error);
    }
  };

  useEffect(() => {
    fetchBalance();
  }, [userId, isPopupVisible]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card>
            <Row align="middle" justify="space-between">
              <Col>
                <Statistic
                  title="Your Leave Balance"
                  value={balance}
                  suffix="days"
                  valueStyle={{ color: "#1677ff", fontWeight: "bold" }}
                />
              </Col>
              <Col>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => setPopupVisible(true)}
                >
                  Request Leave
                </Button>
              </Col>
            </Row>
            <Alert
              message="Note: Leave days are calculated based on working days (Monday to Friday). Weekends are automatically excluded."
              type="info"
              showIcon
              style={{ marginTop: 16 }}
            />
          </Card>
        </Col>
      </Row>

      <Row style={{ marginTop: 24 }}>
        <Col span={24}>
          <LeaveHistory userId={userId} />
        </Col>
      </Row>

      <AddLeave
        visible={isPopupVisible}
        onCancel={() => setPopupVisible(false)}
        // onSuccess={() => setPopupVisible(false)}
        onSuccess={() => {
          fetchBalance();
        }}
        balance={balance}
      />
    </>
  );
};

export default LeavePage;
